import Header from './components/Header'
import Landing from './components/Landing'
import './styles/shared.scss'

function App() {
  return (
    <div className='App'>
      <Header />
      <Landing />
    </div>
  )
}

export default App
